import { render } from "./LocalizationPicker.vue?vue&type=template&id=06cd0e72&scoped=true"
import script from "./LocalizationPicker.vue?vue&type=script&lang=js"
export * from "./LocalizationPicker.vue?vue&type=script&lang=js"

import "./LocalizationPicker.vue?vue&type=style&index=0&id=06cd0e72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cd0e72"]])

export default __exports__